export default __webpack_public_path__ + "static/media/bank.9a572d3b.svg";